import { gql, makeVar, type TypePolicies, useQuery } from '@apollo/client'
import { config } from '@backoffice-frontend/common'
import { useMemo } from 'react'
import {
  type CompleteSelectedRegion,
  isSameSelectedRegion,
  mergeSelectedRegion,
  parsePersistedRegion,
  type SelectedRegion,
  toSelectedRegion,
} from './selectedRegion.utils'

export type { SelectedRegion }

export const GET_SELECTED_REGION = gql`
  query getSelectedRegion {
    getSelectedRegion @client {
      id
      name
      operatorTenant
      timeZoneId
      defaultLanguage
    }
  }
`

export const useGlobalRegion = (): [SelectedRegion | undefined, boolean] => {
  const { data } = useQuery<{ getSelectedRegion?: CompleteSelectedRegion }>(
    GET_SELECTED_REGION,
  )
  const region = data?.getSelectedRegion
  const selectedRegion = useMemo(
    () => region && toSelectedRegion(region),
    [region],
  )
  const loading = false

  return [selectedRegion, loading]
}

export const selectedRegionVar = makeVar<CompleteSelectedRegion | undefined>(
  parsePersistedRegion(config.getRegion()),
)

export const selectRegion = (region?: SelectedRegion) => {
  const currentRegion = selectedRegionVar()
  const nextRegion = region
    ? mergeSelectedRegion(currentRegion, region)
    : undefined
  if (isSameSelectedRegion(currentRegion, nextRegion)) {
    return
  }

  config.setRegion(nextRegion)
  selectedRegionVar(nextRegion)
}

export const MoiaRegionTypePolicies: TypePolicies = {
  Query: {
    fields: {
      getSelectedRegion: {
        read(): CompleteSelectedRegion | undefined {
          return selectedRegionVar()
        },
      },
    },
  },
}
